var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { HistoryCurveDisplayPeriodEnum } from '../../../view-data/components/history-curve/general/history-curve-display-period-enum';
import { HistoryCurveRefreshCycleEnum } from '../../../view-data/components/history-curve/general/history-curve-refresh-cycle-enum';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
import { HistoryCurveConst } from './history-curve-const';
import { CurveType } from '../../../view-data/components/history-curve/general/curve-type';
var HistoryCurveSettingComponent = /** @class */ (function (_super) {
    __extends(HistoryCurveSettingComponent, _super);
    function HistoryCurveSettingComponent(injector, changeDetectorRef, bsModalRef) {
        var _this = _super.call(this, injector, 'historyCurveSettingModal') || this;
        _this.injector = injector;
        _this.changeDetectorRef = changeDetectorRef;
        _this.bsModalRef = bsModalRef;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "allSettings", {
        get: function () {
            return this.arg.allSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "generalSetting", {
        get: function () {
            return this.allSettings.generalSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "channelSetting", {
        get: function () {
            return this._channelSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "calibrationMarkSetting", {
        get: function () {
            return this.allSettings.calibrationMarkSetting;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "configureId", {
        get: function () {
            return this.arg.configureId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveSettingComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    HistoryCurveSettingComponent.prototype.ngOnInit = function () {
        this.active = true;
        if (!this.allSettings || !this.allSettings.channelSetting) {
            this._channelSetting = {
                dataSourceCode: 0
            };
        }
        else {
            this._channelSetting = this.allSettings.channelSetting;
        }
        if (!this.allSettings.calibrationMarkSetting) {
            this.allSettings.calibrationMarkSetting = {
                showCalibration: true,
                showCalibrationDigit: true,
                calibrationDigitFont: {
                    fontSize: HistoryCurveConst.defaultCalibrationDigitFont,
                    isBold: false,
                    isItalic: false,
                    isUnderline: false,
                    color: HistoryCurveConst.defaultFontColor,
                    fontFamily: HistoryCurveConst.defaultFontFamily
                }
            };
        }
        if (!this.allSettings.generalSetting) {
            this.allSettings.generalSetting = {
                curveType: CurveType.Line,
                refreshCycle: HistoryCurveRefreshCycleEnum.ThirtyMinutes,
                displayPeriod: HistoryCurveDisplayPeriodEnum.RecentOneDay
            };
        }
        this.init(this.arg.model);
    };
    // 历史原因不能改private，因为基类已定义public
    HistoryCurveSettingComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        if (!this.staticTabs) {
            this.changeDetectorRef.detectChanges();
        }
        this.staticTabs.tabs[0].active = true;
    };
    HistoryCurveSettingComponent.prototype.save = function () {
        if (this.generalSettingCmp && !this.generalSettingCmp.validate()) {
            this.setActiveTab(0);
            return;
        }
        if (this.channelSettingCmp && !this.channelSettingCmp.validate()) {
            this.setActiveTab(1);
            return;
        }
        if (this.calibrationMarkCmp && !this.calibrationMarkCmp.validate()) {
            this.setActiveTab(2);
            return;
        }
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(3);
            return;
        }
        if (this.channelSettingCmp) {
            this.allSettings.channelSetting = this._channelSetting;
        }
        this.closeModal(this.allSettings);
    };
    HistoryCurveSettingComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    HistoryCurveSettingComponent.prototype.closeModal = function (data) {
        this.saving = false;
        this.active = false;
        this._onClosed.next(data);
        this._onClosed.complete();
        this.bsModalRef.hide();
    };
    __decorate([
        ViewChild('generalSettingRef', { static: false })
    ], HistoryCurveSettingComponent.prototype, "generalSettingCmp", void 0);
    __decorate([
        ViewChild('channelSettingCmp', { static: false })
    ], HistoryCurveSettingComponent.prototype, "channelSettingCmp", void 0);
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], HistoryCurveSettingComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], HistoryCurveSettingComponent.prototype, "staticTabs", void 0);
    __decorate([
        ViewChild('calibrationMark', { static: false })
    ], HistoryCurveSettingComponent.prototype, "calibrationMarkCmp", void 0);
    HistoryCurveSettingComponent = __decorate([
        Component({
            selector: 'history-curve-setting',
            template: "<form name='historyCurveSettingModal' bs-modal-drag id=\"historyCurveSettingModal\" class=\"configure\" *ngIf=\"active\" #historyCurveForm=\"ngForm\" novalidate (ngSubmit)=\"save()\" (onHidden)=\"onHidden()\"> <div class=\"fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"HistoryCurve\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"closeModal()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('GeneralProperty')}}\" customClass=\"m-tabs__item\"> <history-curve-general #generalSettingRef [data]=\"generalSetting\"></history-curve-general> </tab> <tab heading=\"{{lc('Channel')}}\" customClass=\"m-tabs__item\"> <history-curve-channel #channelSettingCmp [data]=\"channelSetting\" [configureId]=\"configureId\"></history-curve-channel> </tab> <tab heading=\"{{lc('CalibrationAndMarker')}}\" customClass=\"m-tabs__item\"> <history-curve-calibration-mark #calibrationMark [data]=\"calibrationMarkSetting\"></history-curve-calibration-mark> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!historyCurveForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"closeModal()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </form>"
        })
    ], HistoryCurveSettingComponent);
    return HistoryCurveSettingComponent;
}(ResizableElementSettingModal));
export { HistoryCurveSettingComponent };
